/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetChatConversationsConversationIdMessagesParams,
  PostChatConversationsConversationIdMessagesExerciseClipParams,
  PostChatConversationsConversationIdMessagesExerciseClipRequestParams,
  PostChatConversationsConversationIdMessagesImageBody,
  PostChatConversationsDirectByEmailParams,
  TrainWithMeModulesChatDtosRequestsMarkReadRequest,
  TrainWithMeModulesChatDtosRequestsReportConversationRequest,
  TrainWithMeModulesChatDtosRequestsSendExerciseCardRequest,
  TrainWithMeModulesChatDtosRequestsSendExerciseClipCardRequest,
  TrainWithMeModulesChatDtosRequestsSendExerciseClipRequestCardRequest,
  TrainWithMeModulesChatDtosRequestsSendMessageRequest,
  TrainWithMeModulesChatDtosRequestsSendPlanCardRequest,
  TrainWithMeModulesChatDtosRequestsSendVideoMessageSlotRequest,
  TrainWithMeModulesChatDtosRequestsSendVoiceMessageSlotRequest,
  TrainWithMeModulesChatDtosRequestsSendWorkoutSummaryCardRequest,
  TrainWithMeModulesChatDtosResponsesChatVideoSlotResponse,
  TrainWithMeModulesChatDtosResponsesChatVoiceSlotResponse,
  TrainWithMeModulesChatDtosResponsesConversationResponse,
  TrainWithMeModulesChatDtosResponsesMessagePageResponse,
  TrainWithMeModulesChatDtosResponsesMessageResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getChatConversations = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesChatDtosResponsesConversationResponse[]>(
      {url: `/chat/conversations`, method: 'GET', signal
    },
      options);
    }




export const getGetChatConversationsQueryKey = () => {
    return [
    `/chat/conversations`
    ] as const;
    }


export const getGetChatConversationsQueryOptions = <TData = Awaited<ReturnType<typeof getChatConversations>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatConversationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatConversations>>> = ({ signal }) => getChatConversations(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatConversations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChatConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof getChatConversations>>>
export type GetChatConversationsQueryError = ErrorType<unknown>


export function useGetChatConversations<TData = Awaited<ReturnType<typeof getChatConversations>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatConversations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatConversations>>,
          TError,
          Awaited<ReturnType<typeof getChatConversations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatConversations<TData = Awaited<ReturnType<typeof getChatConversations>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatConversations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatConversations>>,
          TError,
          Awaited<ReturnType<typeof getChatConversations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatConversations<TData = Awaited<ReturnType<typeof getChatConversations>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChatConversations<TData = Awaited<ReturnType<typeof getChatConversations>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatConversationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postChatConversationsDirectByEmail = (
    params?: PostChatConversationsDirectByEmailParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesChatDtosResponsesConversationResponse>(
      {url: `/chat/conversations/direct-by-email`, method: 'POST',
        params, signal
    },
      options);
    }




export const getPostChatConversationsDirectByEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsDirectByEmail>>, TError,{params?: PostChatConversationsDirectByEmailParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsDirectByEmail>>, TError,{params?: PostChatConversationsDirectByEmailParams}, TContext> => {

const mutationKey = ['postChatConversationsDirectByEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatConversationsDirectByEmail>>, {params?: PostChatConversationsDirectByEmailParams}> = (props) => {
          const {params} = props ?? {};

          return  postChatConversationsDirectByEmail(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostChatConversationsDirectByEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postChatConversationsDirectByEmail>>>

    export type PostChatConversationsDirectByEmailMutationError = ErrorType<unknown>

    export const usePostChatConversationsDirectByEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsDirectByEmail>>, TError,{params?: PostChatConversationsDirectByEmailParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatConversationsDirectByEmail>>,
        TError,
        {params?: PostChatConversationsDirectByEmailParams},
        TContext
      > => {
      return useMutation(getPostChatConversationsDirectByEmailMutationOptions(options), queryClient);
    }
    export const postChatConversationsWithMyTrainer = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesChatDtosResponsesConversationResponse>(
      {url: `/chat/conversations/with-my-trainer`, method: 'POST', signal
    },
      options);
    }




export const getPostChatConversationsWithMyTrainerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsWithMyTrainer>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsWithMyTrainer>>, TError,void, TContext> => {

const mutationKey = ['postChatConversationsWithMyTrainer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatConversationsWithMyTrainer>>, void> = () => {


          return  postChatConversationsWithMyTrainer(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostChatConversationsWithMyTrainerMutationResult = NonNullable<Awaited<ReturnType<typeof postChatConversationsWithMyTrainer>>>

    export type PostChatConversationsWithMyTrainerMutationError = ErrorType<unknown>

    export const usePostChatConversationsWithMyTrainer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsWithMyTrainer>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatConversationsWithMyTrainer>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostChatConversationsWithMyTrainerMutationOptions(options), queryClient);
    }
    export const getChatConversationsConversationIdMessages = (
    conversationId: number,
    params?: GetChatConversationsConversationIdMessagesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesChatDtosResponsesMessagePageResponse>(
      {url: `/chat/conversations/${conversationId}/messages`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetChatConversationsConversationIdMessagesQueryKey = (conversationId: number,
    params?: GetChatConversationsConversationIdMessagesParams,) => {
    return [
    `/chat/conversations/${conversationId}/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetChatConversationsConversationIdMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>, TError = ErrorType<unknown>>(conversationId: number,
    params?: GetChatConversationsConversationIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatConversationsConversationIdMessagesQueryKey(conversationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>> = ({ signal }) => getChatConversationsConversationIdMessages(conversationId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChatConversationsConversationIdMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>>
export type GetChatConversationsConversationIdMessagesQueryError = ErrorType<unknown>


export function useGetChatConversationsConversationIdMessages<TData = Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>, TError = ErrorType<unknown>>(
 conversationId: number,
    params: undefined |  GetChatConversationsConversationIdMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>,
          TError,
          Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatConversationsConversationIdMessages<TData = Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>, TError = ErrorType<unknown>>(
 conversationId: number,
    params?: GetChatConversationsConversationIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>,
          TError,
          Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatConversationsConversationIdMessages<TData = Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>, TError = ErrorType<unknown>>(
 conversationId: number,
    params?: GetChatConversationsConversationIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChatConversationsConversationIdMessages<TData = Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>, TError = ErrorType<unknown>>(
 conversationId: number,
    params?: GetChatConversationsConversationIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatConversationsConversationIdMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatConversationsConversationIdMessagesQueryOptions(conversationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postChatConversationsConversationIdMessages = (
    conversationId: number,
    trainWithMeModulesChatDtosRequestsSendMessageRequest?: BodyType<TrainWithMeModulesChatDtosRequestsSendMessageRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesChatDtosResponsesMessageResponse>(
      {url: `/chat/conversations/${conversationId}/messages`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesChatDtosRequestsSendMessageRequest, signal
    },
      options);
    }




export const getPostChatConversationsConversationIdMessagesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessages>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendMessageRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessages>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendMessageRequest>}, TContext> => {

const mutationKey = ['postChatConversationsConversationIdMessages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatConversationsConversationIdMessages>>, {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendMessageRequest>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  postChatConversationsConversationIdMessages(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostChatConversationsConversationIdMessagesMutationResult = NonNullable<Awaited<ReturnType<typeof postChatConversationsConversationIdMessages>>>
    export type PostChatConversationsConversationIdMessagesMutationBody = BodyType<TrainWithMeModulesChatDtosRequestsSendMessageRequest> | undefined
    export type PostChatConversationsConversationIdMessagesMutationError = ErrorType<unknown>

    export const usePostChatConversationsConversationIdMessages = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessages>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendMessageRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatConversationsConversationIdMessages>>,
        TError,
        {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendMessageRequest>},
        TContext
      > => {
      return useMutation(getPostChatConversationsConversationIdMessagesMutationOptions(options), queryClient);
    }
    export const postChatConversationsConversationIdMessagesExerciseCard = (
    conversationId: number,
    trainWithMeModulesChatDtosRequestsSendExerciseCardRequest?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseCardRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesChatDtosResponsesMessageResponse>(
      {url: `/chat/conversations/${conversationId}/messages/exercise-card`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesChatDtosRequestsSendExerciseCardRequest, signal
    },
      options);
    }




export const getPostChatConversationsConversationIdMessagesExerciseCardMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseCard>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseCardRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseCard>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseCardRequest>}, TContext> => {

const mutationKey = ['postChatConversationsConversationIdMessagesExerciseCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseCard>>, {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseCardRequest>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  postChatConversationsConversationIdMessagesExerciseCard(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostChatConversationsConversationIdMessagesExerciseCardMutationResult = NonNullable<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseCard>>>
    export type PostChatConversationsConversationIdMessagesExerciseCardMutationBody = BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseCardRequest> | undefined
    export type PostChatConversationsConversationIdMessagesExerciseCardMutationError = ErrorType<unknown>

    export const usePostChatConversationsConversationIdMessagesExerciseCard = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseCard>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseCardRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseCard>>,
        TError,
        {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseCardRequest>},
        TContext
      > => {
      return useMutation(getPostChatConversationsConversationIdMessagesExerciseCardMutationOptions(options), queryClient);
    }
    export const postChatConversationsConversationIdMessagesExerciseClip = (
    conversationId: number,
    trainWithMeModulesChatDtosRequestsSendExerciseClipCardRequest?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipCardRequest>,
    params?: PostChatConversationsConversationIdMessagesExerciseClipParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesChatDtosResponsesMessageResponse>(
      {url: `/chat/conversations/${conversationId}/messages/exercise-clip`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesChatDtosRequestsSendExerciseClipCardRequest,
        params, signal
    },
      options);
    }




export const getPostChatConversationsConversationIdMessagesExerciseClipMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseClip>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipCardRequest>;params?: PostChatConversationsConversationIdMessagesExerciseClipParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseClip>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipCardRequest>;params?: PostChatConversationsConversationIdMessagesExerciseClipParams}, TContext> => {

const mutationKey = ['postChatConversationsConversationIdMessagesExerciseClip'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseClip>>, {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipCardRequest>;params?: PostChatConversationsConversationIdMessagesExerciseClipParams}> = (props) => {
          const {conversationId,data,params} = props ?? {};

          return  postChatConversationsConversationIdMessagesExerciseClip(conversationId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostChatConversationsConversationIdMessagesExerciseClipMutationResult = NonNullable<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseClip>>>
    export type PostChatConversationsConversationIdMessagesExerciseClipMutationBody = BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipCardRequest> | undefined
    export type PostChatConversationsConversationIdMessagesExerciseClipMutationError = ErrorType<unknown>

    export const usePostChatConversationsConversationIdMessagesExerciseClip = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseClip>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipCardRequest>;params?: PostChatConversationsConversationIdMessagesExerciseClipParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseClip>>,
        TError,
        {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipCardRequest>;params?: PostChatConversationsConversationIdMessagesExerciseClipParams},
        TContext
      > => {
      return useMutation(getPostChatConversationsConversationIdMessagesExerciseClipMutationOptions(options), queryClient);
    }
    export const postChatConversationsConversationIdMessagesExerciseClipRequest = (
    conversationId: number,
    trainWithMeModulesChatDtosRequestsSendExerciseClipRequestCardRequest?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipRequestCardRequest>,
    params?: PostChatConversationsConversationIdMessagesExerciseClipRequestParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesChatDtosResponsesMessageResponse>(
      {url: `/chat/conversations/${conversationId}/messages/exercise-clip-request`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesChatDtosRequestsSendExerciseClipRequestCardRequest,
        params, signal
    },
      options);
    }




export const getPostChatConversationsConversationIdMessagesExerciseClipRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseClipRequest>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipRequestCardRequest>;params?: PostChatConversationsConversationIdMessagesExerciseClipRequestParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseClipRequest>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipRequestCardRequest>;params?: PostChatConversationsConversationIdMessagesExerciseClipRequestParams}, TContext> => {

const mutationKey = ['postChatConversationsConversationIdMessagesExerciseClipRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseClipRequest>>, {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipRequestCardRequest>;params?: PostChatConversationsConversationIdMessagesExerciseClipRequestParams}> = (props) => {
          const {conversationId,data,params} = props ?? {};

          return  postChatConversationsConversationIdMessagesExerciseClipRequest(conversationId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostChatConversationsConversationIdMessagesExerciseClipRequestMutationResult = NonNullable<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseClipRequest>>>
    export type PostChatConversationsConversationIdMessagesExerciseClipRequestMutationBody = BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipRequestCardRequest> | undefined
    export type PostChatConversationsConversationIdMessagesExerciseClipRequestMutationError = ErrorType<unknown>

    export const usePostChatConversationsConversationIdMessagesExerciseClipRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseClipRequest>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipRequestCardRequest>;params?: PostChatConversationsConversationIdMessagesExerciseClipRequestParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesExerciseClipRequest>>,
        TError,
        {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendExerciseClipRequestCardRequest>;params?: PostChatConversationsConversationIdMessagesExerciseClipRequestParams},
        TContext
      > => {
      return useMutation(getPostChatConversationsConversationIdMessagesExerciseClipRequestMutationOptions(options), queryClient);
    }
    export const postChatConversationsConversationIdMessagesImage = (
    conversationId: number,
    postChatConversationsConversationIdMessagesImageBody?: BodyType<PostChatConversationsConversationIdMessagesImageBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(postChatConversationsConversationIdMessagesImageBody?.ClientId !== undefined) {
 formData.append(`ClientId`, postChatConversationsConversationIdMessagesImageBody.ClientId);
 }
if(postChatConversationsConversationIdMessagesImageBody?.Content !== undefined) {
 formData.append(`Content`, postChatConversationsConversationIdMessagesImageBody.Content);
 }
if(postChatConversationsConversationIdMessagesImageBody?.File !== undefined) {
 formData.append(`File`, postChatConversationsConversationIdMessagesImageBody.File);
 }

      return customInstance<TrainWithMeModulesChatDtosResponsesMessageResponse>(
      {url: `/chat/conversations/${conversationId}/messages/image`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getPostChatConversationsConversationIdMessagesImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesImage>>, TError,{conversationId: number;data?: BodyType<PostChatConversationsConversationIdMessagesImageBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesImage>>, TError,{conversationId: number;data?: BodyType<PostChatConversationsConversationIdMessagesImageBody>}, TContext> => {

const mutationKey = ['postChatConversationsConversationIdMessagesImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesImage>>, {conversationId: number;data?: BodyType<PostChatConversationsConversationIdMessagesImageBody>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  postChatConversationsConversationIdMessagesImage(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostChatConversationsConversationIdMessagesImageMutationResult = NonNullable<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesImage>>>
    export type PostChatConversationsConversationIdMessagesImageMutationBody = BodyType<PostChatConversationsConversationIdMessagesImageBody> | undefined
    export type PostChatConversationsConversationIdMessagesImageMutationError = ErrorType<unknown>

    export const usePostChatConversationsConversationIdMessagesImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesImage>>, TError,{conversationId: number;data?: BodyType<PostChatConversationsConversationIdMessagesImageBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesImage>>,
        TError,
        {conversationId: number;data?: BodyType<PostChatConversationsConversationIdMessagesImageBody>},
        TContext
      > => {
      return useMutation(getPostChatConversationsConversationIdMessagesImageMutationOptions(options), queryClient);
    }
    export const postChatConversationsConversationIdMessagesPlanCard = (
    conversationId: number,
    trainWithMeModulesChatDtosRequestsSendPlanCardRequest?: BodyType<TrainWithMeModulesChatDtosRequestsSendPlanCardRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesChatDtosResponsesMessageResponse>(
      {url: `/chat/conversations/${conversationId}/messages/plan-card`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesChatDtosRequestsSendPlanCardRequest, signal
    },
      options);
    }




export const getPostChatConversationsConversationIdMessagesPlanCardMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesPlanCard>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendPlanCardRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesPlanCard>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendPlanCardRequest>}, TContext> => {

const mutationKey = ['postChatConversationsConversationIdMessagesPlanCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesPlanCard>>, {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendPlanCardRequest>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  postChatConversationsConversationIdMessagesPlanCard(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostChatConversationsConversationIdMessagesPlanCardMutationResult = NonNullable<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesPlanCard>>>
    export type PostChatConversationsConversationIdMessagesPlanCardMutationBody = BodyType<TrainWithMeModulesChatDtosRequestsSendPlanCardRequest> | undefined
    export type PostChatConversationsConversationIdMessagesPlanCardMutationError = ErrorType<unknown>

    export const usePostChatConversationsConversationIdMessagesPlanCard = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesPlanCard>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendPlanCardRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesPlanCard>>,
        TError,
        {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendPlanCardRequest>},
        TContext
      > => {
      return useMutation(getPostChatConversationsConversationIdMessagesPlanCardMutationOptions(options), queryClient);
    }
    export const postChatConversationsConversationIdMessagesVideoSlot = (
    conversationId: number,
    trainWithMeModulesChatDtosRequestsSendVideoMessageSlotRequest?: BodyType<TrainWithMeModulesChatDtosRequestsSendVideoMessageSlotRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesChatDtosResponsesChatVideoSlotResponse>(
      {url: `/chat/conversations/${conversationId}/messages/video/slot`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesChatDtosRequestsSendVideoMessageSlotRequest, signal
    },
      options);
    }




export const getPostChatConversationsConversationIdMessagesVideoSlotMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesVideoSlot>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendVideoMessageSlotRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesVideoSlot>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendVideoMessageSlotRequest>}, TContext> => {

const mutationKey = ['postChatConversationsConversationIdMessagesVideoSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesVideoSlot>>, {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendVideoMessageSlotRequest>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  postChatConversationsConversationIdMessagesVideoSlot(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostChatConversationsConversationIdMessagesVideoSlotMutationResult = NonNullable<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesVideoSlot>>>
    export type PostChatConversationsConversationIdMessagesVideoSlotMutationBody = BodyType<TrainWithMeModulesChatDtosRequestsSendVideoMessageSlotRequest> | undefined
    export type PostChatConversationsConversationIdMessagesVideoSlotMutationError = ErrorType<unknown>

    export const usePostChatConversationsConversationIdMessagesVideoSlot = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesVideoSlot>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendVideoMessageSlotRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesVideoSlot>>,
        TError,
        {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendVideoMessageSlotRequest>},
        TContext
      > => {
      return useMutation(getPostChatConversationsConversationIdMessagesVideoSlotMutationOptions(options), queryClient);
    }
    export const postChatConversationsConversationIdMessagesVoiceSlot = (
    conversationId: number,
    trainWithMeModulesChatDtosRequestsSendVoiceMessageSlotRequest?: BodyType<TrainWithMeModulesChatDtosRequestsSendVoiceMessageSlotRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesChatDtosResponsesChatVoiceSlotResponse>(
      {url: `/chat/conversations/${conversationId}/messages/voice/slot`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesChatDtosRequestsSendVoiceMessageSlotRequest, signal
    },
      options);
    }




export const getPostChatConversationsConversationIdMessagesVoiceSlotMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesVoiceSlot>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendVoiceMessageSlotRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesVoiceSlot>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendVoiceMessageSlotRequest>}, TContext> => {

const mutationKey = ['postChatConversationsConversationIdMessagesVoiceSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesVoiceSlot>>, {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendVoiceMessageSlotRequest>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  postChatConversationsConversationIdMessagesVoiceSlot(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostChatConversationsConversationIdMessagesVoiceSlotMutationResult = NonNullable<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesVoiceSlot>>>
    export type PostChatConversationsConversationIdMessagesVoiceSlotMutationBody = BodyType<TrainWithMeModulesChatDtosRequestsSendVoiceMessageSlotRequest> | undefined
    export type PostChatConversationsConversationIdMessagesVoiceSlotMutationError = ErrorType<unknown>

    export const usePostChatConversationsConversationIdMessagesVoiceSlot = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesVoiceSlot>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendVoiceMessageSlotRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesVoiceSlot>>,
        TError,
        {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendVoiceMessageSlotRequest>},
        TContext
      > => {
      return useMutation(getPostChatConversationsConversationIdMessagesVoiceSlotMutationOptions(options), queryClient);
    }
    export const postChatConversationsConversationIdMessagesWorkoutSummaryCard = (
    conversationId: number,
    trainWithMeModulesChatDtosRequestsSendWorkoutSummaryCardRequest?: BodyType<TrainWithMeModulesChatDtosRequestsSendWorkoutSummaryCardRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesChatDtosResponsesMessageResponse>(
      {url: `/chat/conversations/${conversationId}/messages/workout-summary-card`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesChatDtosRequestsSendWorkoutSummaryCardRequest, signal
    },
      options);
    }




export const getPostChatConversationsConversationIdMessagesWorkoutSummaryCardMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesWorkoutSummaryCard>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendWorkoutSummaryCardRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesWorkoutSummaryCard>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendWorkoutSummaryCardRequest>}, TContext> => {

const mutationKey = ['postChatConversationsConversationIdMessagesWorkoutSummaryCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesWorkoutSummaryCard>>, {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendWorkoutSummaryCardRequest>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  postChatConversationsConversationIdMessagesWorkoutSummaryCard(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostChatConversationsConversationIdMessagesWorkoutSummaryCardMutationResult = NonNullable<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesWorkoutSummaryCard>>>
    export type PostChatConversationsConversationIdMessagesWorkoutSummaryCardMutationBody = BodyType<TrainWithMeModulesChatDtosRequestsSendWorkoutSummaryCardRequest> | undefined
    export type PostChatConversationsConversationIdMessagesWorkoutSummaryCardMutationError = ErrorType<unknown>

    export const usePostChatConversationsConversationIdMessagesWorkoutSummaryCard = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesWorkoutSummaryCard>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendWorkoutSummaryCardRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatConversationsConversationIdMessagesWorkoutSummaryCard>>,
        TError,
        {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsSendWorkoutSummaryCardRequest>},
        TContext
      > => {
      return useMutation(getPostChatConversationsConversationIdMessagesWorkoutSummaryCardMutationOptions(options), queryClient);
    }
    export const postChatConversationsConversationIdRead = (
    conversationId: number,
    trainWithMeModulesChatDtosRequestsMarkReadRequest?: BodyType<TrainWithMeModulesChatDtosRequestsMarkReadRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/chat/conversations/${conversationId}/read`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesChatDtosRequestsMarkReadRequest, signal
    },
      options);
    }




export const getPostChatConversationsConversationIdReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdRead>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsMarkReadRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdRead>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsMarkReadRequest>}, TContext> => {

const mutationKey = ['postChatConversationsConversationIdRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatConversationsConversationIdRead>>, {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsMarkReadRequest>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  postChatConversationsConversationIdRead(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostChatConversationsConversationIdReadMutationResult = NonNullable<Awaited<ReturnType<typeof postChatConversationsConversationIdRead>>>
    export type PostChatConversationsConversationIdReadMutationBody = BodyType<TrainWithMeModulesChatDtosRequestsMarkReadRequest> | undefined
    export type PostChatConversationsConversationIdReadMutationError = ErrorType<unknown>

    export const usePostChatConversationsConversationIdRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdRead>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsMarkReadRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatConversationsConversationIdRead>>,
        TError,
        {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsMarkReadRequest>},
        TContext
      > => {
      return useMutation(getPostChatConversationsConversationIdReadMutationOptions(options), queryClient);
    }
    export const postChatConversationsConversationIdReport = (
    conversationId: number,
    trainWithMeModulesChatDtosRequestsReportConversationRequest?: BodyType<TrainWithMeModulesChatDtosRequestsReportConversationRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/chat/conversations/${conversationId}/report`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesChatDtosRequestsReportConversationRequest, signal
    },
      options);
    }




export const getPostChatConversationsConversationIdReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdReport>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsReportConversationRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdReport>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsReportConversationRequest>}, TContext> => {

const mutationKey = ['postChatConversationsConversationIdReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatConversationsConversationIdReport>>, {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsReportConversationRequest>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  postChatConversationsConversationIdReport(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostChatConversationsConversationIdReportMutationResult = NonNullable<Awaited<ReturnType<typeof postChatConversationsConversationIdReport>>>
    export type PostChatConversationsConversationIdReportMutationBody = BodyType<TrainWithMeModulesChatDtosRequestsReportConversationRequest> | undefined
    export type PostChatConversationsConversationIdReportMutationError = ErrorType<unknown>

    export const usePostChatConversationsConversationIdReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatConversationsConversationIdReport>>, TError,{conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsReportConversationRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatConversationsConversationIdReport>>,
        TError,
        {conversationId: number;data?: BodyType<TrainWithMeModulesChatDtosRequestsReportConversationRequest>},
        TContext
      > => {
      return useMutation(getPostChatConversationsConversationIdReportMutationOptions(options), queryClient);
    }
